/**
 * CR-6451: draft-then-apply for the NCR filter panel.
 *
 * The panel edits a draft copy of the applied filters; Apply pushes the draft
 * into the page's applied state in one go, so the list, the chip counts and
 * the URL all move once. Anything that changes the applied state from outside
 * the panel (quick chips, column-header funnels, deep links, Clear all)
 * re-seeds the draft so the panel never shows a stale value.
 *
 * @param applied - the filters the list is currently showing
 * @returns the draft, a patcher, and a reset
 * @example
 * const { draft, patchDraft } = useNCRFilterDraft(appliedValues);
 */
import { useEffect, useState } from 'react';
import type { NCRFiltersState } from './ncrFilterParams';

export function useNCRFilterDraft(applied: NCRFiltersState) {
  const [draft, setDraft] = useState<NCRFiltersState>(applied);
  const appliedKey = JSON.stringify(applied);

  useEffect(() => {
    setDraft(JSON.parse(appliedKey) as NCRFiltersState);
  }, [appliedKey]);

  const patchDraft = (next: Partial<NCRFiltersState>) =>
    setDraft((prev) => ({ ...prev, ...next }));

  return { draft, patchDraft, setDraft };
}
